import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Sectors from "@/pages/Sectors";
import SectorsDefence from "@/pages/SectorsDefence";
import SectorsCommodities from "@/pages/SectorsCommodities";
import Contact from "@/pages/Contact";
import Healthcare from "@/pages/Healthcare";
import Legal from "@/pages/Legal";
import Trade from "@/pages/Trade";

const ScrollToTop = () => {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return null;
};

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                <Navbar />
                <main className="pt-20">
                    <Routes>
                        <Route path="/" element={<><ScrollToTop /><Home /></>} />
                        <Route path="/about" element={<><ScrollToTop /><About /></>} />
                        <Route path="/services" element={<><ScrollToTop /><Services /></>} />
                        <Route path="/sectors" element={<><ScrollToTop /><Sectors /></>} />
                        <Route path="/sectors/defence-aerospace" element={<><ScrollToTop /><SectorsDefence /></>} />
                        <Route path="/defence-aerospace" element={<><ScrollToTop /><SectorsDefence /></>} />
                        <Route path="/sectors/commodities-international-trade" element={<><ScrollToTop /><SectorsCommodities /></>} />
                        <Route path="/commodities-international-trade" element={<><ScrollToTop /><SectorsCommodities /></>} />
                        <Route path="/healthcare" element={<><ScrollToTop /><Healthcare /></>} />
                        <Route path="/trade" element={<><ScrollToTop /><Trade /></>} />
                        <Route path="/legal" element={<><ScrollToTop /><Legal /></>} />
                        <Route path="/contact" element={<><ScrollToTop /><Contact /></>} />
                    </Routes>
                </main>
                <Footer />
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: '#0A1F44',
                            color: '#F8FAFC',
                            border: '1px solid rgba(201, 161, 74, 0.3)',
                            borderRadius: 0,
                            fontFamily: 'Work Sans, sans-serif',
                        }
                    }}
                />
            </BrowserRouter>
            </div>
        </HelmetProvider>
    );
}

export default App;
